<div *ngIf="errorService.hasErrors()" class="alert alert-danger">
  <p *ngFor="let error of errorService.errors">{{ error | translate }}</p>
</div>
